import React from 'react';
const links = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-cream px-5 py-14" data-id="element-94" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-95" data-mp="3gh3q6bfwg0dk">
        <p className="text-sm font-bold uppercase tracking-[0.24em] text-teal" data-id="element-96" data-mp="32ovvcp86ejhi">
          <span aria-hidden="true" data-id="element-97" data-mp="36oxwmxa01aw9">🧘</span> Yoga With Tina
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft" data-id="element-98" data-mp="36n3grxdl48z1">
          A complete, ready-to-teach beginner yoga system for newly certified instructors.
        </p>

        <nav aria-label="Footer" className="mt-7" data-id="element-99" data-mp="36d3qyjl4vnu">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-100" data-mp="3ldanxgy565kf">
            {links.map(link => <li key={link} data-id="element-101" data-mp="3qblyxv06am48">
                <a href="#offer" className="text-ink-soft underline-offset-4 transition-colors hover:text-terracotta hover:underline" data-id="element-102" data-mp="29zgl41oc4umn">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 border-t border-sage/25 pt-6 text-xs text-ink-soft" data-id="element-103" data-mp="3gah0br9yxf4s">
          © 2026 Yoga With Tina — All rights reserved.
        </p>
      </div>
    </footer>;
}